var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', _vm.image)}}},[_c('v-lazy-image',{attrs:{"src":_vm.imageURL,"src-placeholder":"/img/placeholder.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }